module.exports = __webpack_public_path__ + "img/cash_top.1acb7e4c.png";